import Route from 'cio/routes/base';
import AttributesIndexController from 'cio/pods/person/attributes/index/controller';

export default class IndexRoute extends Route {
  deactivate() {
    super.deactivate();

    (this.controller as AttributesIndexController).set('searchTerm', '');
  }
}
